<template>
  <div class="widget-page">
    <el-card>
      <div slot="header">网站接入代码</div>
      <el-form inline>
        <el-form-item label="HTTP地址"><el-input v-model="host" style="width:240px;" /></el-form-item>
        <el-form-item label="WS地址"><el-input v-model="wsHost" style="width:240px;" /></el-form-item>
        <el-form-item label="H5站点">
          <el-input v-model="h5Host" style="width:260px;" placeholder="独立部署时填写，如 http://localhost:5173" />
        </el-form-item>
        <el-form-item><el-button type="primary" @click="load">生成</el-button></el-form-item>
      </el-form>
      <el-input type="textarea" :rows="8" v-model="snippet" readonly />
      <div class="block-title">移动端 H5 直达链接（App / 短信 / 站内打开）</div>
      <p class="hint">
        需在下方链接中携带可用的 WebSocket 地址（站点为 HTTPS 时请使用 <code>wss://</code>）。若使用仓库内独立项目 <code>visitor-h5</code>（如 <code>npm run dev</code>），请在上方「H5站点」填写其根地址，生成链接会自动附带 <code>api</code> 指向 HTTP API。留空则仍为 API 同源下的 <code>/chat/h5.html</code>。
      </p>
      <el-input type="textarea" :rows="3" v-model="h5Url" readonly class="h5-input" />
    </el-card>

    <el-card class="doc-card">
      <div slot="header">可选参数说明（嵌入脚本）</div>
      <p class="hint">
        下方代码里的 <code>__CS_CONF__</code> 中，除 <code>server</code>、<code>appKey</code> 由生成逻辑填充外，其余字段均可按需填写<strong>字符串</strong>；不需要的可保持 <code>''</code>。
        必须在<strong>加载</strong> <code>/widget/sdk.js</code> <strong>之前</strong>写好配置（Vue/React 等 SPA 请在挂载挂件前赋值，且整站只加载一次脚本）。
      </p>
      <el-table :data="embedParams" border size="small" class="doc-table">
        <el-table-column prop="key" label="字段名" width="150" />
        <el-table-column prop="need" label="必填" width="72" align="center" />
        <el-table-column prop="desc" label="含义" min-width="220" />
        <el-table-column prop="example" label="示例" min-width="160" show-overflow-tooltip />
      </el-table>
      <div class="sub-head">如何传入（嵌入）</div>
      <pre class="code-sample">w.__CS_CONF__={
  server:u,appKey:k,wsServer:'wss://…',
  externalUserId:'会员ID',
  customerEmail:'user@example.com',
  customerName:'张三',
  chatTitle:'联系我们',
  chatSubtitle:'工作日 9:00-18:00',
  launcherText:'咨询客服',
  visitorNickname:'访客小A'
};</pre>
    </el-card>

    <el-card class="doc-card">
      <div slot="header">可选参数说明（H5 链接 Query）</div>
      <p class="hint">
        在上方生成的链接后面用 <code>&amp;</code> 拼接参数（需先对取值做 URL 编码）。除下列参数外，<code>app_key</code>、<code>ws</code> 已由生成结果带上。
      </p>
      <el-table :data="h5Params" border size="small" class="doc-table">
        <el-table-column prop="key" label="参数名" width="168" />
        <el-table-column prop="need" label="必填" width="72" align="center" />
        <el-table-column prop="desc" label="含义" min-width="220" />
        <el-table-column prop="example" label="示例" min-width="200" show-overflow-tooltip />
      </el-table>
      <div class="sub-head">拼接示例（H5）</div>
      <pre class="code-sample">{{ h5AppendExample }}</pre>
      <p class="hint">
        独立域名部署 H5 时，生成器已在链接中加入 <code>api</code>（指向上方 HTTP API）；手写链接时请自行补上 <code>&amp;api=https://你的API根地址</code>。
      </p>
    </el-card>
  </div>
</template>

<script>
import { API_BASE, WS_URL } from '../config/endpoints';
import { getWidgetSnippet } from '../api/merchant';

export default {
  data() {
    return {
      host: API_BASE,
      wsHost: WS_URL,
      h5Host: '',
      snippet: '',
      h5Url: '',
      embedParams: [
        { key: 'server', need: '自动', desc: 'HTTP API 根地址，与上方「HTTP地址」一致，勿手写修改。', example: 'https://api.example.com' },
        { key: 'appKey', need: '自动', desc: '商户密钥，用于识别租户。', example: '（生成结果中已有）' },
        { key: 'wsServer', need: '建议', desc: '浏览器连接的 WebSocket 完整地址；HTTPS 站点请用 wss。', example: 'wss://ws.example.com:8787' },
        { key: 'externalUserId', need: '否', desc: '贵站已登录用户的稳定业务 ID，便于同一用户关联会话。', example: "会员 user_id：'88421'" },
        { key: 'customerEmail', need: '否', desc: '用户邮箱；格式合法时走后端「已识别访客」逻辑（可与 externalUserId 同时传）。', example: "'user@corp.com'" },
        { key: 'customerName', need: '否', desc: '对外展示姓名，客服侧会话列表等场景可参考。', example: "'李四'" },
        { key: 'chatTitle', need: '否', desc: '挂件头部主标题，留空则使用内置默认「在线客服」。', example: "'售前咨询'" },
        { key: 'chatSubtitle', need: '否', desc: '挂件头部副标题（可为固定文案）；不传则在接入后显示客服昵称。', example: "'工作日在线'" },
        { key: 'launcherText', need: '否', desc: '右下角悬浮按钮文案。', example: "'点我咨询'" },
        { key: 'visitorNickname', need: '否', desc: '访客消息气泡旁展示的昵称缩写（取前两字）；可与 customerName 区分设置。', example: "'小王'" }
      ],
      h5Params: [
        { key: 'app_key', need: '是', desc: '商户密钥（生成链接已包含）。', example: '—' },
        { key: 'ws', need: '是', desc: 'WebSocket 地址（生成链接已包含，注意编码）。', example: '—' },
        { key: 'api / server', need: '否', desc: 'HTTP API 根地址；仅当 H5 页面与接口不同源时需要传。', example: 'https://api.example.com' },
        { key: 'external_user_id', need: '否', desc: '同嵌入里的 externalUserId，下划线命名。', example: '88421' },
        { key: 'customer_email', need: '否', desc: '同嵌入里的 customerEmail。', example: 'user@corp.com' },
        { key: 'customer_name', need: '否', desc: '同嵌入里的 customerName。', example: '李四' },
        { key: 'visitor_nickname', need: '否', desc: '同嵌入里的 visitorNickname。', example: '小王' },
        { key: 'chat_title', need: '否', desc: 'H5 顶栏标题。', example: '联系我们' },
        { key: 'chat_subtitle', need: '否', desc: 'H5 顶栏固定副文案；不传则接入后显示客服昵称。', example: '工作日 9-18' },
        {
          key: 'lang / locale',
          need: '否',
          desc: '界面语言（页内可切换）：en、de、tr、zh-CN、zh-TW、ja、ko、hi、vi、pt、es、id；亦支持 zh、en-us 等别名。',
          example: 'en'
        }
      ],
      h5AppendExample:
        '…/?app_key=…&ws=…&api=https://你的API\n' +
        '（或与 API 同源时 …/chat/h5.html?app_key=…&ws=…）\n' +
        '&external_user_id=88421\n' +
        '&customer_email=user%40corp.com\n' +
        '&customer_name=%E5%BC%A0%E4%B8%89\n' +
        '&chat_title=%E5%94%AE%E5%89%8D%E5%92%A8%E8%AF%A2'
    };
  },
  methods: {
    async load() {
      const { data } = await getWidgetSnippet(this.host, this.wsHost, this.h5Host);
      const d = data.data || {};
      this.snippet = d.snippet || '';
      this.h5Url = d.h5_chat_url || '';
    }
  },
  created() {
    this.load();
  }
};
</script>

<style scoped>
.widget-page .doc-card {
  margin-top: 16px;
}
.block-title {
  margin-top: 16px;
  font-weight: 600;
  font-size: 14px;
  color: #303133;
}
.hint {
  margin: 8px 0 0;
  font-size: 13px;
  color: #909399;
  line-height: 1.65;
}
.hint code {
  padding: 1px 6px;
  margin: 0 2px;
  font-size: 12px;
  background: #f4f4f5;
  border-radius: 4px;
  color: #606266;
}
.h5-input {
  margin-top: 8px;
}
.doc-table {
  margin-top: 12px;
}
.sub-head {
  margin: 16px 0 8px;
  font-weight: 600;
  font-size: 13px;
  color: #606266;
}
.code-sample {
  margin: 0;
  padding: 12px 14px;
  font-size: 12px;
  line-height: 1.55;
  background: #f8fafc;
  border: 1px solid #ebeef5;
  border-radius: 8px;
  overflow-x: auto;
  color: #334155;
  white-space: pre-wrap;
  word-break: break-all;
}
</style>

